<div class="flex flex-col justify-center text-center -mt-3" appDynamicScript>
  <div src="https://cdn.trustindex.io/loader.js?8d6e14578af9850d5016e0446b7" ></div>
</div>

<div class="flex flex-col justify-center text-center bg-white rounded-xl p-2 -mt-3">
  <p class="mt-0 font-theme-source text-sm pl-2 pr-2 text-left">
    <span class="font-bold underline mr-1">Informations</span> ·
    <span class="mr-1 ml-1">Recherche</span> ·
    <span class="ml-1">Finalisation</span>
  </p>

  <div class="mt-0 w-full md:w-[576px] ml-auto mr-auto">
    <div class="flex flex-col w-full justify-center items-center mt-5 text-left pl-6 pr-6 " [formGroup]="whoForm" >

      <app-form-input [tabIndex]="1" placeholder="john@gmail.com" [formGroup]="whoForm" name="email" autocomplete="email"
                      [big]="false" [black]="true" [label]="referralCode() ? 'Email de mon ami(e)' : 'Mon Email'"
                      class="mt-1 w-full" (change)="socialTrackService.trackGAEvent('who_input_email')"></app-form-input>

      <div *ngIf="whoForm.controls.email.valid && !showBadEmail" class="mt-2 font-theme-source text-theme-blackp-2 text-sm font-normal text-center">
        <p>L'Email sert à confirmer ta place · <span class="font-bold">Pas de spam.</span></p>
      </div>

      <div *ngIf="whoForm.controls.email.invalid && showBadEmail" class="mt-4 font-theme-source text-theme-black bg-theme-red-110 p-2 text-base font-normal text-center rounded-lg text-white">
        <p>Email invalide</p>
      </div>

      <app-sex-button *ngIf="sessionResource.session.value()?.topic != 'lgbt_w'"
                      class="mt-7" [label]="referralCode() ? 'Elle est une femme qui recherche un homme' : 'Je suis une femme qui recherche un homme'"
                      [selected]="leadResources.currentLead.value()?.sex == 'F'" (click)="selectSexOrTopicOption('F')" />

      <app-sex-button *ngIf="sessionResource.session.value()?.topic != 'lgbt_w'"
                      class="mt-2" [label]="referralCode() ? 'Il est un homme qui recherche une femme' : 'Je suis un homme qui recherche une femme'"
                      [selected]="leadResources.currentLead.value()?.sex == 'M'" (click)="selectSexOrTopicOption('M')" />

      <app-sex-button *ngIf="sessionResource.session.value()?.topic == 'lgbt_w'"
                      class="mt-10" [label]="referralCode() ? 'Elle est une femme (lesbienne)' : 'Je suis une femme (lesbienne)'"
                      [selected]="leadResources.currentLead.value()?.topicOption == 'FF'" (click)="selectSexOrTopicOption('FF')" />

      <app-sex-button *ngIf="sessionResource.session.value()?.topic == 'lgbt_w'"
                      class="mt-2" [label]="referralCode() ? 'Elle est une femme (bisexuelle)' : 'Je suis une femme (bisexuelle)'"
                      [selected]="leadResources.currentLead.value()?.topicOption == 'FB'" (click)="selectSexOrTopicOption('FB')" />

      <app-sex-button *ngIf="sessionResource.session.value()?.topic == 'lgbt_w'"
                      class="mt-2" [label]="referralCode() ? 'Elle ne préfère pas répondre' : 'Elle ne préfère pas répondre'"
                      [selected]="leadResources.currentLead.value()?.topicOption == 'FX'" (click)="selectSexOrTopicOption('FB')" />

    </div>
  </div>
</div>



